import React, { useState, useContext, useEffect } from 'react';
import {AdvancedMarker, InfoWindow, Map, useMap} from '@vis.gl/react-google-maps';
import { FilterContext } from './Context';

const icons = {
    'affordable-housing': '/app/themes/monarchprivate/dist/img/icon-affordable-housing.png',
    'historic-rehabilitation': '/app/themes/monarchprivate/dist/img/icon-historic-rehabilitation.png',
    'renewable-energy': '/app/themes/monarchprivate/dist/img/icon-renewable-energy.png'
}

function getLocationIcon(location, icons) {
    if(location.project_types?.length) {
        return icons[location.project_types[0].slug] || icons['affordable-housing'];
    }

    return icons['affordable-housing'];
}

const ProejctMap = ({locations}) => {
    const map = useMap();

    const zoomMap = (zoom) => {
        map?.setZoom(zoom);
    }

    const centerMap = (center) => {
        map?.panTo(center);
    }

    const defaultZoom = 5;
    const defaultCenter = {
        lng : -98.4842,
        lat : 39.0119
    };

    const [selected, setSelected] = useState(null);

    const {creditTypeFilter, projectTypeFilter } = useContext(FilterContext);

    useEffect(() => {
        setSelected(null);
        zoomMap(defaultZoom);
        centerMap(defaultCenter);
	}, [creditTypeFilter, projectTypeFilter]);

    return (
        <div className="project-map-holder">
            <Map 
                defaultZoom={defaultZoom} 
                defaultCenter={defaultCenter}
                controlled={false}
                mapId="4781479257423666"
                tilt={0}
            >
                {locations.map((location) => (
                    <AdvancedMarker 
                        key={Math.random() * Math.random()}
                        position={{ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) }}
                        onClick={() => {
                            setSelected(location);
                        }}
                        title={location.name}
                    >
                        <img src={getLocationIcon(location, icons)} width={32} height={32} />
                    </AdvancedMarker>
                ))}

                {selected && (
                    <InfoWindow
                        position={{ lat: parseFloat(selected.latitude), lng: parseFloat(selected.longitude) }}
                        onClose={() => setSelected(null)}
                        disableAutoPan={false}
                    >
                        <div className="project-map-info">
                            {selected.url ? (
                                <a href={selected.url}>
                                    {selected.thumbnail && <img className="project-map-info-thumbnail" src={selected.thumbnail} alt={selected.name} />} 
                                    <h5 className="project-map-info-heading" dangerouslySetInnerHTML={{__html: selected.name}}></h5>
                                </a>
                            ) : (
                                <div>
                                    {selected.thumbnail && <img className="project-map-info-thumbnail" src={selected.thumbnail} alt={selected.name} />} 
                                    <h5 className="project-map-info-heading" dangerouslySetInnerHTML={{__html: selected.name}}></h5>
                                </div>
                            )}

                            <p className="project-map-info-address">{selected.city},  {selected.state}</p>

                            {selected.url && (
                                <a className="project-map-info-button" href={selected.url}>
                                    Read More
                                    <span className="icon icon-arrow-right"></span>
                                </a>
                            )}

                            <p className="project-map-info-tags">
                                {selected.project_types.map((type) => (
                                    <a key={type.slug} className="project-map-info-tag" href={`/impact-projects/?project_type=${type.slug}`}>{type.name}</a>
                                ))}
                            </p>
                        </div>
                    </InfoWindow>
                )}
            </Map>
        </div>
    )
}

export default ProejctMap;